import isEmpty from 'lodash/isEmpty';

export const columnHasSomeActiveFilter = (filter) => {
  return Object.values(filter).some((filterValue) => !isEmpty(filterValue));
};

export const normalizeFilters = (filters) => {
  const normalizedFilters = Object.keys(filters).reduce((acc, columnIndex) => {
    const columnFilters = filters[columnIndex];
    const columnActiveFilter = columnHasSomeActiveFilter(columnFilters);
    const toBeFilteredColumnValue = columnActiveFilter ? Number(columnIndex) : '';

    if (acc.columnToBeFiltered) {
      acc.columnToBeFiltered.push(toBeFilteredColumnValue);
    } else {
      acc.columnToBeFiltered = [toBeFilteredColumnValue];
    }
    
    Object.keys(columnFilters).forEach((filterKey) => {
      const filterValue = columnFilters[filterKey];

      if (acc[filterKey]) {
        acc[filterKey].push(filterValue);

        return;
      }

      acc[filterKey] = [filterValue];
    });

    return acc;
  }, {});

  return normalizedFilters;
};

export const denormalizeFilters = (filters = {}) => {
  const { columnToBeFiltered = [] } = filters;
  const values = {
    andOR: filters.andOR,
    operator1: filters.operator1,
    operator2: filters.operator2,
    whereClause1: filters.whereClause1,
    whereClause2: filters.whereClause2,
  };

  const denormalizedFilters = {};

  columnToBeFiltered.forEach((columnIndex, valueIndex) => {
    denormalizedFilters[columnIndex] = Object.keys(values).reduce((acc,  filterKey) => {
      const currentFilterValue = values[filterKey] || []; 
      const currentColumnValue = currentFilterValue[valueIndex];
      
      acc[filterKey] = currentColumnValue;

      return acc;
    }, {});
  });

  return denormalizedFilters;
};

export const getScrollableElement = (tableWrapper) => {
  return tableWrapper.querySelector('.rt-table');
};

export const scrollTop = (tableWrapper) => {
  const scrollableContentElement = getScrollableElement(tableWrapper);
    
  scrollableContentElement.scrollTop = 0;
};

export const scrollLeft = (tableWrapper) => {
  const scrollableContentElement = getScrollableElement(tableWrapper);
    
  scrollableContentElement.scrollLeft = 0;
};

export const scrollToStart = (tableWrapper) => {
  scrollTop(tableWrapper);
  scrollLeft(tableWrapper);
};

export const getHeader = (tableWrapper) => {
  return tableWrapper.querySelector('.rt-thead');
};

export const getBody = (tableWrapper) => {
  return tableWrapper.querySelector('.rt-tbody');
};